var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-block-wrapper"},[_c('header',{class:[ _vm.headerBetween && 'justify-between', _vm.$slots.body && 'mb-2' ]},[(_vm.$slots.header)?_vm._t("header"):_vm._e()],2),(_vm.$slots.body)?_c('div',{staticClass:"body"},[_vm._t("body")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }